module.exports = __webpack_public_path__ + "img/locker-room-gal-3.77b8b64a.jpg";